export class SafeJSON {

    // return default string if JSON is not safe
    static getWithDefault(id: string, json: any): any {
        const value = this.get(id, json);
        if (value === '' || value === null ) {
            return '-';
        }
        return value;
    }

    // return default string if JSON is not safe
    static getNumber(id: string, json: any): number {
        const value = this.get(id, json);
        if (value === '' || value === null ) {
            return 0;
        }
        return value;
    }

    static get(id: string, json: any): any {
        const tokens: string[] = id.split('.');
        let result = json || '';
        for (let token of tokens) {
            const value = SafeJSON.getValue(token, result);
            if (value) {
                result = value;
            } else {
                return '';
            }
        }
        return result;
    }

    private static getValue(token: string, json: any): any {
        let value;
        if (token.indexOf('[') === -1) {
            value = json[token];
        } else {
           const subtokens = token.split(/\[|\]/);
           let [arrName, arrIndex] = subtokens;
           const arr = json[arrName];
           value = +arrIndex < arr.length ? arr[arrIndex] : '';
        }
        return value;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/safe-json.ts